import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";

import AdminPage from "../AdminPage";
import Table from "../NewTable";
import EditModal from "./EditModal";

import { ReactComponent as EditIcon } from "../../assets/images/edit.svg";

import api from "../../providers/api";

import { addToast } from "../../helpers";

import "./style.scss";

function NotificationsManagement() {
  const intl = useIntl();
  const [loading, setLoading] = useState(true);
  const [notifications, setNotifications] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [modalData, setModalData] = useState({});

  function onShowEditModal(obj) {
    setShowEditModal(true);
    setModalData(obj);
  }

  const columns = [
    {
      key: "event",
      cell: "Title",
      header: intl.formatMessage({ id: "notification.event" }),
      width: "20%",
    },
    {
      key: "englishMessage",
      cell: "NotificationEnglish",
      header: intl.formatMessage({ id: "notification.english-message" }),
      width: "35%",
    },
    {
      key: "arabicMessage",
      cell: "NotificationArabic",
      header: intl.formatMessage({ id: "notification.arabic-message" }),
      width: "35%",
    },
  ];

  async function getNotificationsData() {
    try {
      setLoading(true);
      const res = await api.notification.getAllConfig();
      setNotifications(res.Data || []);
    } catch (err) {
      addToast.error(err.message, {
        toastId: "get-users-error",
      });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getNotificationsData();
  }, []);

  function onCloseModal() {
    setShowEditModal(false);
  }

  function updateNotificationsList(Data) {
    if (Data) {
      let _notifications = notifications.map((item) =>
        item.ID === Data.ID ? Data : item
      );

      setNotifications(_notifications);
    }
    setShowEditModal(false);
  }

  const actions = [
    {
      key: "edit",
      variant: "primary",
      Icon: EditIcon,
      "tooltip-position": "buttom",
      tooltip: intl.formatMessage({ id: "common.update" }),
      onClick: (item) => {
        onShowEditModal(item);
      },
    },
  ];

  return (
    <AdminPage
      loading={loading}
      title={intl.formatMessage({
        id: "notification.notifications-configuration",
      })}
    >
      <div className="notifications-management">
        <div className="notifications-management__content">
          <Table data={notifications} columns={columns} actions={actions} />
        </div>
        {showEditModal ? (
          <EditModal
            isOpen={showEditModal}
            closeModal={onCloseModal}
            callback={updateNotificationsList}
            data={modalData}
          />
        ) : null}
      </div>
    </AdminPage>
  );
}

export default NotificationsManagement;
